import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Breadcrumbs = ({ className, pageName, urls, withNewUI }) => {
  const breadcrumbClasses = classNames(
    className,
    'gn-content',
    { 'gn-breadcrumbs--newUI': withNewUI },
  );
  const lastLink = urls.slice(-1)[0];
  const links = urls.map(link => (
    <li className="gn-breadcrumbs__element u-inline" key={`${link.url}.${link.name}`}>
      {!link.url ? (
        <button className="gn-breadcrumbs__path" onClick={link.onClick}>
          {link.name}<div className="gn-breadcrumbs__separator" />
        </button>
      ) : (
        <Link className="gn-breadcrumbs__path" to={link.url}>
          {link.name}<div className="gn-breadcrumbs__separator" />
        </Link>
      )}
    </li>));

  return (
    <div className={breadcrumbClasses}>
      <div className="gn-breadcrumbs gn-breadcrumbs--desktop">
        <ul className="u-inline gn-breadcrumbs__list">
          {links}
          <li className="gn-breadcrumbs__element u-inline">
            <span className="gn-breadcrumbs__pageName">{pageName}</span>
          </li>
        </ul>
      </div>

      {lastLink && (
        <div className="gn-breadcrumbs gn-breadcrumbs--mobile">
          {!lastLink.url ? (
            <button className="gn-breadcrumbs__link" onClick={lastLink.onClick}>
              <span className="gn-breadcrumbs__label gn-breadcrumbs__label--fullContainerWidth">
                <div className="gn-breadcrumbs__separator" />
                {lastLink.name}
              </span>
            </button>
          ) : (
            <Link className="gn-breadcrumbs__link" to={lastLink.url}>
              <span className="gn-breadcrumbs__label gn-breadcrumbs__label--fullContainerWidth">
                <div className="gn-breadcrumbs__separator" />
                {lastLink.name}
              </span>
            </Link>
          )}
        </div>
      )}
    </div>);
};

Breadcrumbs.defaultProps = {
  withNewUI: false,
};

Breadcrumbs.propTypes = {
  className: PropTypes.string,
  pageName: PropTypes.string,
  urls: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    name: PropTypes.string,
    onClick: PropTypes.func,
  })).isRequired,
  withNewUI: PropTypes.bool,
};

export default Breadcrumbs;
